export default {
  data: () => ({
    mobileLinks: [
      {
        to: "/forms",
        icon: "mdi-file-document-edit ",
        text: "Formulários",
        permission: { act: "create", on: "DoneForm" },

        // permission: 'default'
      },
      {
        to: "/done_forms",
        icon: "mdi-file-document-box-check",
        text: "Enviados",
        permission: { act: "read", on: "DoneForm" },

        // permission: 'default'
      },
      {
        to: "/activity",
        icon: "mdi-file-replace",
        // icon: "mdi-file-refresh",
        // icon: "mdi-file-send",
        text: "Parciais",
        permission: { act: "create", on: "DoneForm" },
        //   permission: 'default',
      },

      {
        to: "/tasks",
        icon: "mdi-calendar-check",
        // icon: "mdi-file-refresh",
        // icon: "mdi-file-send",
        text: "Agendamentos",
        permission: { act: "read", on: "User" },
        //   permission: 'default',
      },
    ],
    sideLinks: [
      // {
      //   to: '/scout',
      //   icon: 'mdi-eye',
      //   text: 'Observador',
      //   permission: {act: 'read', on: 'Dashboard'},
      // //   permission: 'default'
      // },
      // {
      //   to: "/flows",
      //   icon: "mdi-check-network-outline",
      //   text: "Fluxos",
      //   permission: { act: "read", on: "Flow" },

      //   // permission: 'default'
      // },
      {
        to: "/dashboard",
        icon: "mdi-chart-bar",
        text: "Dashboard",
        permission: { act: "read", on: "Dashboard" },

        // permission: 'default'
      },
      {
        to: '/admin_ckb',
        icon: 'mdi-shield',
        text: 'Administração',
        permission: {act: 'manage', on: 'Checkbits'},
        
        // permission: 'default'
      },
      {
        to: "/action_plans",
        icon: "mdi-target",
        text: "Planos de Ação",
        permission: { act: "read", on: "DoneForm" },

        // permission: 'default'
      },
      {
        to: "/data_export",
        icon: "mdi-file-excel",
        text: "Exportações",
        permission: { act: "read", on: "DoneForm" },
      },
      /*{
        to: "/custom_fields",
        icon: "mdi-database-edit",
        text: "Listas Personalizadas",
        permission: { act: "create", on: "Form" },
      },*/
      {
        to: "/company/register",
        icon: "mdi-office-building",
        text: "Minha Empresa",
        permission: { act: "read", on: "Department" },
      },

      {
        to: "/profile",
        icon: "mdi-account",
        text: "Perfil",
        permission: { act: "read", on: "User" },

        // permission: 'default'
      },
      // {
      //   to: '/settings',
      //   icon: 'settings',
      //   text: 'Gerenciar',
      //   permission: {act: 'read', on: 'Dashboard'},
      // //   permission: 'admin'
      // },
      // {
      //   to: '/analytics',
      //   icon: 'dashboard',
      //   text: 'Análise',
      //   permission: {act: 'read', on: 'Dashboard'},
      // //   permission: 'admin',
      //   feature: 'custom_analytics'
      // },
    ],
    lastLinks: [
      // {
      //   to: '/about',
      //   icon: 'info',
      //   text: 'Sobre',
      //   permission: {act: 'read', on: 'Dashboard'},
      // //   permission: 'default'
      // },
      //{
      //  to: "/billing",
      //  icon: "mdi-currency-usd",
      //  text: "Faturas",
      //  permission: { act: "manage", on: "Checkbits" },
      //},
      {
        to: "/feedback",
        icon: "mdi-chat-question-outline",
        text: "Suporte",
        permission: { act: "read", on: "Dashboard" },

        // permission: 'admin'
      },
      {
        to: "/logout",
        icon: "logout",
        text: "Sair",
        permission: { act: "read", on: "User" },

        // permission: 'default'
      },
    ],
  }),
  methods: {
    defaultLinks() {
      return;
    },
  },
};
